import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getDevices, getTokenDiscovery } from '~/src/api/watch-everywhere';
import { useTariffList } from '~/src/components/WatchEverywhere/AuthControl/useTariffList';
import TariffCardControl from '~/src/components/WatchEverywhere/TariffCardControl';
import { TState } from '~/src/store';
import { selectDomain } from '~/src/store/selectors/domain';
import selectProviderId from '~/src/store/selectors/selectProviderId';

import DevicesList from './devices-list';

import * as ST from './styled';

const AuthControl = () => {
    const { tariffActiveList = [], tariffInactiveList = [], reload } = useTariffList();
    const [devicesList, setDevicesList] = useState([]);
    const [accessTokenWatchEverywhere, setAccessTokenWatchEverywhere] = useState(null);

    const { domain, accessToken } = useSelector((state: TState) => ({
        domain: selectDomain(state),
        accessToken: state.auth.accessToken,
        providerId: selectProviderId(state),
    }));

    useEffect(() => {
        if (domain && accessToken) {
            getTokenDiscovery({ domain, accessToken })
                .then(accessTokenFromDiscovery => {
                    getDevices({ accessTokenWatchEverywhere: accessTokenFromDiscovery })
                        .then(devices => {
                            setAccessTokenWatchEverywhere(accessTokenFromDiscovery);
                            setDevicesList(devices);
                        });
                });
        }
    }, [domain, accessToken]);

    useEffect(() => {
        if (domain && accessToken) {
            reload();
        }
    }, [domain, accessToken, reload]);

    return (
        <ST.AuthControlWrapper>
            <ST.TariffListWrapper>
                {
                    (tariffActiveList.length || tariffInactiveList.length)
                        ? <ST.DevicesTitle data-test='watch-everywhere-title'>Сейчас у вас подключен тариф</ST.DevicesTitle>
                        : null
                }
                <ST.TariffListWrapper data-test='watch-everywhere-active'>
                    {
                        tariffActiveList.map(item => (
                            <TariffCardControl key={item.serviceId} tariff={item} onConnect={reload}/>
                        ))
                    }
                </ST.TariffListWrapper>
                <ST.TariffListWrapper data-test='watch-everywhere-inactive'>
                    {
                        tariffInactiveList.map(item => (
                            <TariffCardControl key={item.serviceId} tariff={item} onConnect={reload}/>
                        ))
                    }
                </ST.TariffListWrapper>
            </ST.TariffListWrapper>
            <DevicesList
                devicesList={devicesList}
                accessTokenWatchEverywhere={accessTokenWatchEverywhere}
            />
        </ST.AuthControlWrapper>
    );
};

export default AuthControl;
